import { BaseEntity } from "@app/models/rest/base-entity";
import { Roster } from "@app/models/rest/roster/roster";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("nonWorkingDays")
export class NonWorkingDay extends BaseEntity {
  date: Date;
  description: string;
  roster: Roster;
}
